import React from 'react';
import ModalBasic from '../../../pages/component/ModalBasic.js';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown.js';
import moment from 'moment';
import ValidationText from '../../../utils/validation/ValidationText.js';

const ItemDetailsModel = (props) => {
    return (
        <ModalBasic
            id="adding-item-popUp"
            modalOpen={props.setItemDetailsModel}
            setModalOpen={props.setOpenModel}
            title="Item Details"
            noCloseIcon={true}
        >
            <div className="item-form ">
                <div className="form-table">
                    {props.pendingGRNPurchaseEntryList && props.pendingGRNPurchaseEntryList.length > 0
                        ?
                        <div className="itemList-table mb-4">
                            <div className="table-container" style={{ maxHeight: "20vh" }}>
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[20%]'>GRN No</td>
                                            <td className='w-[20%]'>GRN Date</td>
                                            <td className='w-[20%]'>Inv. No</td>
                                            <td className='w-[20%]'>Item name</td>
                                            <td className='w-[20%]'>Qty</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.pendingGRNPurchaseEntryList.map((item, key) => (
                                            <tr key={key} className='hover:bg-[#f3f4f673] cursor-pointer' onClick={() => props.selectPendingGRNEntry(item)}>
                                                <td>{item.grnEntryPartyDetailId.grnNo}</td>
                                                <td>{moment(item.grnEntryPartyDetailId.grnDate).format("DD MMM yyyy")}</td>
                                                <td>{item.grnEntryPartyDetailId.invoiceNo}</td>
                                                <td>{item.rawMaterialId ? item.rawMaterialId.rmName : item.packageMaterialId.pmName}</td>
                                                <td>{item.qty}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : props.validationTextForGRNEntry ?
                            <p
                                className=' mb-3 w-fit p-2 rounded-[8px]'
                                style={{
                                    color: "brown",
                                    fontSize: "13px",
                                    border: "1px solid #a52a2a57",
                                    outline: " 2px solid rgb(165 42 42 / 10%)",
                                }} >
                                {props.validationTextForGRNEntry}</p>
                            : null}

                    <div className="item-grp !flex !gap-2.5 !mb-2.5">
                        <div className="input-grp min-w-[24.5%]">
                            <label>GRN No</label>
                            <input
                                type="text"
                                id="grnNo"
                                name="grnNo"
                                value={props.itemDetails.grnNo}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "grnNo")
                                }
                                className={`inputFocus`}
                                disabled
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Item Name</label>
                            {props.itemDetails.grnType === 'Raw' ?
                                <MultiSelectDropdown
                                    drpIdentity="itemId"
                                    options={props.rawMaterialList}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={(selected) =>
                                        props.setFilterParametersForItemTable(
                                            selected,
                                            "itemId"
                                        )
                                    }
                                    allowSelectAll={false}
                                    value={props.rawMaterialList.filter(
                                        (party) => party.value === props.itemDetails.itemId
                                    )}
                                    isDisabled={true}
                                />
                                :
                                <MultiSelectDropdown
                                    drpIdentity="itemId"
                                    options={props.packingMaterialDropDownList}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    className={` ${props.validState?.error?.itemId ? "errorInput" : ""}`}
                                    onChange={(selected) =>
                                        props.setFilterParametersForItemTable(
                                            selected,
                                            "itemId"
                                        )
                                    }
                                    allowSelectAll={false}
                                    value={props.packingMaterialDropDownList.filter(
                                        (party) => party.value === props.itemDetails.itemId
                                    )}
                                    isDisabled={true}
                                />
                            }
                            {/* <ValidationText error={props.validState.error.itemId} /> */}
                        </div>
                        <div className="input-grp min-w-[24.5%]">
                            <label>Batch No</label>
                            <input
                                type="text"
                                id="batchNo"
                                name="batchNo"
                                value={props.itemDetails.batchNo}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "batchNo")
                                }
                                className={`inputFocus`}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">

                        <div className="input-grp w-full">
                            <label>Quantity</label>
                            <input
                                type="number"
                                id="qty"
                                name="qty"
                                className="inputFocus"
                                // disabled={props.itemDetails.batchClearingEntryId === null}
                                value={props.itemDetails.qty}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "qty")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Rate</label>
                            <input
                                type="number"
                                id="rate"
                                name="rate"
                                className="inputFocus"
                                value={props.itemDetails.rate}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "rate")
                                }
                                // disabled
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Amount</label>
                            <input
                                type="number"
                                id="amount"
                                name="amount"
                                className='inputFocus'
                                value={props.itemDetails.amount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "amount")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp w-full">
                            <label>Other</label>
                            <input
                                type="number"
                                id="other"
                                name="other"
                                className='inputFocus'
                                value={props.itemDetails.other}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "other")
                                }
                            />
                        </div>

                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">
                        <div className="input-grp w-full">
                            <label>HSN Code</label>
                            <input
                                className={`inputFocus ${props.validState?.error?.hsnCodeName ? "errorInput" : ""}`}
                                type="number"
                                id="hsnCodeName"
                                name="hsnCodeName"
                                value={props.itemDetails.hsnCodeName}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "hsnCodeName")
                                }
                            />
                            {/* <ValidationText error={props.validState.error.hsnCodeName} /> */}
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>SGST [%]</label>
                            <input className="inputFocus"
                                type="number"
                                id="sgst"
                                name="sgst"
                                value={props.itemDetails.sgst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "sgst")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>CGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="cgst"
                                name="cgst"
                                value={props.itemDetails.cgst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "cgst")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>IGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="igst"
                                name="igst"
                                value={props.itemDetails.igst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "igst")
                                }
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>UGST [%]</label>
                            <input className="inputFocus"
                                type="number"
                                id="ugst"
                                name="ugst"
                                value={props.itemDetails.ugst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "ugst")
                                }
                            />
                        </div>
                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">
                        <div className="input-grp w-full">
                            <label>Taxable Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="taxableAmount"
                                name="taxableAmount"
                                value={props.itemDetails.taxableAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "taxableAmount")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>SGST Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="sgstAmount"
                                name="sgstAmount"
                                value={props.itemDetails.sgstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "sgstAmount")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>CGST Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="cgstAmount"
                                name="cgstAmount"
                                value={props.itemDetails.cgstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "cgstAmount")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>IGST Amount</label>
                            <input className="inputFocus"

                                type="number"
                                id="igstAmount"
                                name="igstAmount"
                                value={props.itemDetails.igstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "igstAmount")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>UGST Amount</label>
                            <input className="inputFocus"
                                type="number"
                                id="ugstAmount"
                                name="ugstAmount"
                                value={props.itemDetails.ugstAmount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "ugstAmount")
                                }
                                disabled
                            />
                        </div>
                    </div>
                    <div className="btn-grp flex gap-2.5 mt-5">
                        {props.isEditing ?
                            <button
                                className="add-btn"
                                onClick={props.addItemToItemArray}
                            >
                                Save
                            </button> :
                            <button
                                className="add-btn"
                                onClick={props.addItemToItemArray}
                            >
                                Add
                            </button>
                        }

                        <button
                            className="cancel-btn"
                            onClick={props.closePopUp}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
};

export default ItemDetailsModel;